var React = require('react');

function Supercarrier (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Super Carrier"),React.createElement("g",{"id":"g1417","key":2},[React.createElement("path",{"id":"path836","className":"cls-1","d":"M55.67,93.17H72.33L114,51.5,72.33,9.83H55.67L14,51.5Z","key":0}),React.createElement("path",{"id":"path856","className":"cls-1","d":"M114,76.5,72.33,118.17H55.67L14,76.5","key":1})])]);
}

Supercarrier.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Supercarrier;

Supercarrier.default = Supercarrier;
